import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useSelector } from "@jti/store";
import { PrizeLocator } from "@jti/ui";
import { RedeemDialog } from "../RedeemDialog/RedeemDialog";
export const TrustedPlaces = (props) => {
    const [dialogData, setDialogData] = useState({});
    const { points: { balance }, tier: { name }, } = useSelector((state) => state.loyaltyCore);
    const { costLabel, availablePointsLabel, balanceAfterRedemptionLabel, primaryCta, secondaryCta, dialogTitle, dialogTitleConfirmation, bottomText, pointsLabel, confirmationMessage, confirmationMessagePlural, codeLabel, codeInfo, emailHint, emailLabel, unitLabel, ctaLabel, loadMoreButtonLabel, searchHeader, searchBar, rewardsText, backToListLabel, searchButton, storesCount, getDirectionLabel, defaultLng, defaultLat, flotiqContentType, flotiqApiKey, filtersTranslations, categoryFilterTitle, noOffersText, pagination, venuePopUpOffersCount, currentPositionButtonText, newOfferDays, newLabel, oneDayLabel, daysLabel, outOfStockLabel, } = props;
    const context = {
        labels: {
            loadMoreLabel: loadMoreButtonLabel,
            redeemButtonLabel: ctaLabel,
            backToListLabel,
            getDirectionLabel,
            searchHeader,
            pointsLabel,
            rewardsText,
            searchBar,
            searchButton,
            storesCount,
            categoryFilterTitle,
            noOffersText,
            venuePopUpOffersCount,
            currentPositionButtonText,
            newOfferDays,
            newLabel,
            oneDayLabel,
            daysLabel,
            outOfStockLabel,
        },
        pagination,
        userPointsBalance: balance,
        handleRedeemClick: setDialogData,
        tier: name,
    };
    const resetDialogData = () => setDialogData({});
    return (_jsxs(_Fragment, { children: [_jsx(PrizeLocator, { context: context, defaultLat: defaultLat, defaultLng: defaultLng, flotiqApiKey: flotiqApiKey, flotiqContentType: flotiqContentType, filtersTranslations: filtersTranslations }), _jsx(RedeemDialog, { pointsBalance: balance, prizeData: dialogData, onCloseDialog: resetDialogData, labels: {
                    costLabel,
                    availablePointsLabel,
                    balanceAfterRedemptionLabel,
                    primaryCta,
                    secondaryCta,
                    dialogTitle,
                    dialogTitleConfirmation,
                    bottomText,
                    pointsLabel,
                    confirmationMessage,
                    confirmationMessagePlural,
                    codeLabel,
                    codeInfo,
                    emailHint,
                    emailLabel,
                    unitLabel,
                } })] }));
};
//# sourceMappingURL=TrustedPlaces.js.map